import { Box, Flex, Spacing } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const rows1 = [1, 2, 3, 4, 5, 6];
const rows2 = [1, 2, 3];

export const Loading = memo(() => {
    return (
        <Flex direction='column'>
            <Box bordered radius='small' spacing='16 24'>
                <Flex spacing='0 8'>
                    <Skeleton width={20} height={20} />

                    <Skeleton width={200} height={20} />
                </Flex>

                <Spacing height={16} />

                <Flex direction='column' spacing='8 0'>
                    {rows1.map((row) => (
                        <Flex spacing='0 8' key={row} alignItems='center'>
                            <Skeleton width={20} height={20} />

                            <Skeleton width={140} height={16} />
                        </Flex>
                    ))}
                </Flex>
            </Box>

            <Box bordered radius='small' spacing='16 24'>
                <Flex spacing='0 8'>
                    <Skeleton width={20} height={20} />

                    <Skeleton width={200} height={20} />
                </Flex>

                <Spacing height={16} />

                <Flex direction='column' spacing='8 0'>
                    {rows2.map((row) => (
                        <Flex spacing='0 8' key={row} alignItems='center'>
                            <Skeleton width={20} height={20} />

                            <Skeleton width={140} height={16} />
                        </Flex>
                    ))}
                </Flex>
            </Box>
        </Flex>
    );
});

Loading.displayName = 'Loading';
